/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');

var react = require('react');

var useMouseEvents = require('./useMouseEvents.js');

var createStateObject = function createStateObject(event) {
  return {
    clientX: event.clientX,
    clientY: event.clientY,
    screenX: event.screenX,
    screenY: event.screenY
  };
};

var useMouseState = function useMouseState() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useState = react.useState({
    clientX: 0,
    clientY: 0,
    screenX: 0,
    screenY: 0
  }),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useMouseEvents = useMouseEvents.default(ref),
      onMouseMove = _useMouseEvents.onMouseMove;

  onMouseMove(function (event) {
    var nextState = createStateObject(event);
    setState(nextState);
  });
  return state;
};

exports.default = useMouseState;